/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

export const REGEX = {
	EMAIL: /^([\w.%+\-]+)@((?!-)[\w\-]+(?<!-)\.)+([a-z]{2,})$/i,
	PHONE: /^\d{3} \d{3} \d{4}$/,
	NICKNAME_ALPHA_NUMERIC_SPECIAL_CHAR: /^(?!\s)[a-zA-Z0-9 ]+(?<!\s)$/,
	CARD_NUMBER_MASK: /[0-9](?=([0-9]{4}))/g,
	IDENTIFICATION: /^\d+$/,
	BIRTH_DATE: /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
	PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{2,20}$/,
	ONLY_NUMBERS: /^\d+$/,
	SEARCH_REDIRECT_SUFFIX: /[&]?\*=$/,
};
